
export default {
  props: {
    total: {
      // 分页数量，计算好传进来
      type: Number,
      default: 0
    },
    index: {
      // 当前分页
      type: Number,
      default: 0
    },
    url: {
      // 跳转的页面路由部分，页面部分路由拼接；例如zh-cn/news/1.html；那么就传zh-cn/news/
      type: String,
      default: ''
    },
    typeurl: {
      // 跳转类型true为a链接跳转，false为js跳转
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      query: '' // 参数
    }
  },
  mounted() {
    const paramObj = this.$route.query
    for (const k in paramObj) {
      if (k && ['c', 'keyword', 'tag'].includes(k)) {
        this.query += (this.query?.includes('?') ? '&' : '?') + `${k}=${paramObj[k]}`
      }
    }
  },
  methods: {
    tab(ind) {
      if (this.typeurl) return
      this.$emit('tab', ind)
    }
  }
}
